import React from 'react';
import {useFormContext} from 'react-hook-form';
import styles from '@/components/help/common/FormContainer/FormContainer.module.scss';
import {ControllerWrapper} from '@/components/common';
import {SoopInputBox} from '@soop-ui/soop-ui';
import {FORM_FIELDS} from '@/constants/help/index';
import {handleNumericInput} from '@/utils/help/formUtils';
import {useFormClear} from '@/hooks/help/useFormClear';
import {useFormKeyHandler} from '@/hooks/help/useFormKeyHandler';

const PHONE_NUMBER_ERROR_MESSAGE = '휴대폰 번호를 입력해 주세요.';
const PHONE_NUMBER_INVALID_MESSAGE = '유효하지 않은 휴대전화번호 형식입니다.';

const PHONE_NUMBER_REGEX = /^01[016789]{1}[0-9]{3,4}[0-9]{4}$/;

const PhoneNumber = () => {
  const {
    formState: {errors},
  } = useFormContext();
  const {handleClear} = useFormClear();
  const {handleFormKeyDown} = useFormKeyHandler();

  const onClear = () =>
    handleClear(FORM_FIELDS.PHONE_NUMBER, {shouldFocus: true});

  return (
    <div className={`${styles.section}`}>
      <label className={styles.label}>
        휴대폰 번호 <em>*</em>
      </label>
      <ControllerWrapper
        component={SoopInputBox}
        needsBlurWrapper={true}
        clearable={true}
        onClear={onClear}
        size='44'
        name={FORM_FIELDS.PHONE_NUMBER}
        rules={{
          required: PHONE_NUMBER_ERROR_MESSAGE,
          pattern: {
            value: PHONE_NUMBER_REGEX,
            message: PHONE_NUMBER_INVALID_MESSAGE,
          },
        }}
        placeholder="'-' 없이 휴대폰 번호 입력"
        onInput={handleNumericInput}
        error={!!errors[FORM_FIELDS.PHONE_NUMBER]}
        helperStatus={errors[FORM_FIELDS.PHONE_NUMBER] ? 'error' : undefined}
        helperText={errors[FORM_FIELDS.PHONE_NUMBER]?.message as string}
        onKeyDown={(e) => {
          handleFormKeyDown(e);
        }}
      />
    </div>
  );
};

export default PhoneNumber;
